import { Route } from "react-router-dom";
import LocationScreen from "../../container/LocationScreen";
import CreateLocationContainer from "../../container/LocationScreen/CreateLocation";
import { APP_URLS } from "../../utils/constant";

const LocationRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.LOCATION.HOME}
          element={<LocationScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.LOCATION.CREATE}
          element={<CreateLocationContainer />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.LOCATION.EDIT}
          element={<CreateLocationContainer isEdit={true} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.LOCATION.COPY}
          element={<CreateLocationContainer isCopy={true} />}
        />
      )}
    </>
  );
};

export default LocationRoutes;
